import { Module } from 'vuex';

import { RootState } from '@/store/types';

import fertilization from '../fertilization/store';
import fertilizationCereals from '../fertilizationCereals/store';
import seedingSoy from '../seeding-soy/store';
import seeding from '../seeding/store';
import spraying from '../spraying/store';
import { ApplicationMapsState } from './types';

const vuexModule: Module<ApplicationMapsState, RootState> = {
  namespaced: true,
  modules: {
    fertilization,
    seeding,
    seedingSoy,
    fertilizationCereals,
    spraying,
  },
  actions: {
    resetAll({ dispatch }) {
      dispatch('fertilization/reset');
      dispatch('seeding/reset');
      dispatch('seedingSoy/reset');
      dispatch('fertilizationCereals/reset');
      dispatch('spraying/reset');
    },
  },
};

export default vuexModule;
